// extracted by mini-css-extract-plugin
export default {"select":"FormMultiselect_select__URnLh"};